import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Button } from 'foundations-components/transitional/components/Button';
import { applyConditionalFormattingToConfigColumn } from '../utils';
import { AddIcon } from 'foundations-assets';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ConfigConditionalFormattingReapply = ({
  report,
  onChange,
  onReapplyToColumn,
  selectedColumnName
}) => {
  return /*#__PURE__*/_jsx(FormControl, {
    children: /*#__PURE__*/_jsxs(Button, {
      use: "link",
      onClick: () => {
        onReapplyToColumn();
        const nextReport = applyConditionalFormattingToConfigColumn(report, selectedColumnName);
        if (nextReport) {
          onChange(nextReport);
        }
      },
      children: [/*#__PURE__*/_jsx(AddIcon, {
        size: "300"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "report-customization-components.customization-components.conditional-formatting.add-button"
      })]
    })
  });
};
export default ConfigConditionalFormattingReapply;